'use client'

import { Navbar } from './navbar'
import { Footer } from './footer'
import { BookDemoForm } from './book-demo-form'
import { useCascadeReveal } from '../lib/use-cascade-reveal'

/* =========================================
   PAGE SHELL
   Wraps every subpage with the shared nav + footer and the
   cascade-reveal observer. Children stay server-rendered.
   demoForm={false} drops the book-a-demo section for pages that
   carry their own form (e.g. /contact).
   ========================================= */
export function PageShell({
  children,
  demoForm = true,
}: {
  children: React.ReactNode
  demoForm?: boolean
}) {
  useCascadeReveal()

  return (
    <main>
      <Navbar />
      {children}
      {demoForm && <BookDemoForm />}
      <Footer />
    </main>
  )
}
